import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../app/store"
import { useNavigate } from "react-router-dom"
import { token } from "../../features/Auth/authSlice"
type Props = {}
export default function Reminderjobs({}: Props) {
  const dispatch = useAppDispatch()
  const urlSearchParams = new URLSearchParams(window.location.search)
  const tokens = urlSearchParams.get("token")
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(token(tokens as any))
    if (tokens) {
      window.location.reload()
      navigate("/dashboard/approved-job")
    }
  }, [tokens])

  return <>Loding.......</>
}
